import styled, { css } from "styled-components/macro";

const colorList = {
	'main': '#73972c',
	'main-opa8': 'rgba(34, 193, 151, 0.8)',
	'main-opa6': 'rgba(34, 193, 151, 0.6)',
	'main-opa4': 'rgba(34, 193, 151, 0.4)',
	'main-opa2': 'rgba(34, 193, 151, 0.2)',
	'black100': '#000',
	'black80': '#333',
	'black60': '#666',
	'black40': '#999',
	'black20': '#ccc',
	'black10': '#e5e5e5',
	'black5': '#f2f2f2',
};

export const MonitoringData = styled.div`
	display: flex;
	flex-direction: column;
	padding: 20px 40px;	

	// place style
	.acc-place{
		border-radius: 4px 4px 0 0;
		&.FARM{
			border-right: 1px solid ${colorList["black40"]};
			border-bottom: 1px solid ${colorList["black40"]};
		}

		&.CONTAINER{
			
		}

		&.SECTION{
			
		}
		.acc-child{
			
		}

		.acc-tit{
			display: flex;
			align-items: center;
			font-size: 0.9em;
			width: 100%;
			padding: 12px 8px;
			color: #333;
			border-top: 1px solid ${colorList["black40"]};
			transition: 0.2s all ease;

			&::before{
				content: '';
				display: inline-block;
				width: 20px;
				height: 20px;
				margin-right: 8px;
			}

			&:hover{
				cursor: pointer;
				background-color: ${colorList["main-opa2"]};
			}

			&::after{
				content: '';
				display: inline-block;
				width: 14px;
				height: 14px;
				margin-left: auto;
				background: url(/img/SelectArrow.svg) no-repeat center / 100%;
			}

			&.active{
				
				background-color: ${colorList["black80"]};
				color: #fff !important;
				::before{
					filter: brightness(100);
				}
				::after{
					background: url(/img/ArrowTop.svg) no-repeat center / 100%;
					filter: brightness(100);
				}
			}
		}

		.acc-con{
			position: relative;
			&::before{
				content: '';
				display: inline-block;
				width: 1px;
				border-left:1px dashed ${colorList["black20"]};
				position: absolute;
    		height: 100%;
				left: 10px
			}
		}

		&.FARM{
			>.acc-tit {
				color: ${colorList["black100"]};
				&::before{
					background: url(/img/farm.svg) no-repeat center center / cover;			
				}
			}
		}
		&.CONTAINER{
			>.acc-tit {
				color: ${colorList["black80"]};
				&::before{
					background: url(/img/container.svg) no-repeat center center / cover;			
				}
			}
		}
		&.SECTION{
			>.acc-tit {
				color: ${colorList["black60"]};
				&::before{
					background: url(/img/section.svg) no-repeat center center / cover;			
				}
			}
		}
		&.BOX{
			>.acc-tit {
				&::before{
					background: url(/img/section.svg) no-repeat center center / cover;			
				}
			}
		}
	}

	// equip style
	.acc-equip{
		border-radius: 4px;
		padding: 20px;
    padding-left: 40px;
		.equip-tit{
			font-size : 0.9em;
			color: ${colorList["black80"]};
			border-left: 4px solid ${colorList["black80"]};
			padding-left: 8px;
		}
		.acc-equip-list.sensor-group{
			margin-bottom : 40px;
			&:last-child{
				margin-bottom: 0;
			}
		}

		.acc-equip-list.actualtor-group{
			display: inline-block;
			margin-right: 8px;
			&:last-child{
				margin-right: 0;
			}
		}
	}

	// sensor style
	.acc-sensor{
		display: flex;
		flex-wrap: wrap;
    flex-direction: row;
		margin-top: 10px;
		gap: 8px;
		.acc-sensor-list{
			flex: 1;
			border:1px solid #dddddd;
			border-radius: 4px;
			min-width: 127px;
			
			.sensor-tit{
				display: flex;
				align-items: center;
				justify-content: center;

				font-size: 0.9em;
				
				color: #fff;
				height: 3em;
				
				&.normal-y{
					background-color: ${colorList["main"]};
				}
				&.normal-n{
					background-color: ${colorList["black40"]};
				}
			}
			.sensor-val{
				display: flex;
				align-items: center;
				justify-content: center;

				height: 5em;
				.value{
					font-size: 1.5em;
					position: relative;
					.unit{
						font-size: 14px;
					}
				}
				@media screen and (max-width: 745px) {
					.value{
						font-size: 1.25em;
					}
				}

				
			}
		}
	}

	// actuator style
	.acc-actuator{
		display: flex;
		flex-wrap: wrap;
    flex-direction: row;
		margin-top: 10px;
		gap: 8px;
		.acc-actuator-list{
			display: flex;
			flex: 1;
			border:1px solid #dddddd;
			border-radius: 4px;
			min-width: 100px;
			max-width: 160px;
			height: 6em;
			
			&:hover{
				cursor: pointer;
				background-color: #73972c26;
			}

			.actuator-con{
				width: 100%;
				padding: 10px;
				background: url(/img/sett.png) no-repeat right 10px bottom 10px / 50px;
			}

			.actuator-aircon{
				width: 100%;
				padding: 10px;
				background: url(/img/temperature.png) no-repeat right 10px bottom 10px / 50px;
			}

			.actuator-humid{
				width: 100%;
				padding: 10px;
				background: url(/img/humidifier.png) no-repeat right 10px bottom 10px / 50px;
			}

			.actuator-heat{
				width: 100%;
				padding: 10px;
				background: url(/img/heat_exchanger.png) no-repeat right 10px bottom 10px / 50px;
			}

			.actuator-light{
				width: 100%;
				padding: 10px;
				background: url(/img/lighting.png) no-repeat right 10px bottom 10px / 50px;
			}

			.actuator-fan{
				width: 100%;
				padding: 10px;
				background: url(/img/fan.png) no-repeat right 10px bottom 10px / 50px;
			}
		}
	}

	// actuator modal style
	.actuator-setting{
		li{
			list-style: none;
		}
/* 
		display: flex;
    flex-direction: row;
    flex-wrap: wrap;
		justify-content: flex-start;
		align-items: center;
		gap: 20px; */

		display: grid;
		grid: 1fr / repeat(3, 1fr);
		gap: 1em;
		@media screen and (max-width: 1100px) {
			grid: 1fr / repeat(2, 1fr);
		}
		@media screen and (max-width: 745px) {
			grid: 1fr / repeat(1, 1fr);
		}

		.actuator-setting-list{
			display: flex;
			flex-direction: column;
			align-items: center;

			/* min-width: 100px; */

			padding: 14px 14px 10px 14px;

			/* border:1px solid #dddddd; */
			box-shadow: rgba(0, 0, 0, 0.24) 0px 3px 8px;
			border-radius: 4px;

			.top{
				display: flex;
				flex-direction: column;
				justify-content: space-between;
				
				margin-bottom: 2em;
				.act-tit{
					color: #888;
					font-size: 0.9em;
					margin-bottom: 1em;
				}
				.act-con{
					display: flex;
					justify-content: space-between;
					align-items: center;
					input{
						background: transparent;
						border:0;
						border-bottom: 1px solid #ddd;
						/* width: 75%; */
						height: 40px;
						font-size: 1em;
						text-indent: 10px;
					}
					span{
						font-size: 0.8em;
					}
				}
			}
			.bottom{
				button{
					padding: 8px 16px;
					border-radius: 4px;
					border:0;
					background-color: #73972c;
					color: #fff;
					transition: filter 0.3s ease;
					&:hover{
						cursor: pointer;
						filter: brightness(110%);
					}
				}
			}
		}
	}

	// common style
	.no-data-txt{
		color: rgb(101,101,101);
	}
	.last-update{
		display: flex;
		justify-content: flex-end;
		margin-bottom: 12px;
		margin-right: 10px;
		p{
			font-size: 0.8em;
			color: ${colorList["black60"]};
			&::before{
				content: '※ ';
			}
		}
	}

	
	@media screen and (max-width: 1100px) {
		.acc-sensor-list {
			flex: 0 1 auto !important;
			min-width: 100px !important;
		}
	}
`;


// export const MonitoringItem = styled.div`
// 	display: flex;
// 	flex-direction: column;
// 	padding: 20px 0;
// 	border-bottom: 1px solid #dddddd;
// 	.item-tit{
// 		background-color: yellow;
// 	}
// `;
